module.exports = __webpack_public_path__ + "img/EZD_20220514_1.9bc33877.png";